// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"_1_K7D","trackingLink":"xEl1y","noData":"Z7ghC"};